import { ApiGet, ApiPost } from "../../libs/helper";
import { IApiResponse } from "../../libs/type-interface";
import { Common } from "mony-component"

export const FetchReferralReward = async (): Promise<IApiResponse> => {
    const response = await ApiGet(`/saas/referral-rewards`);
    return response;
}
